import { useCallback, useEffect, useMemo, useState } from 'react'
import { useProjectPlanSnapshotRepository } from '../../../../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'
import { TeamSelectRow } from '../model'

type UseTeamSelectDataProps = {
  snapshotUuid: string
  selectedUuids: string[]
}

export const useTeamSelectData = ({
  snapshotUuid,
  selectedUuids,
}: UseTeamSelectDataProps) => {
  const { fetchReferencedValues } = useProjectPlanSnapshotRepository()
  const [partialRows, setPartialRows] = useState<
    Omit<TeamSelectRow, 'selected'>[]
  >([])

  const fetchSnapshotData = useCallback(
    async (uuid: string) => {
      const response = await fetchReferencedValues(uuid, 'TEAM_ENTITY')
      return response.map(resp => ({
        uuid: resp.value,
        displayName: resp.name,
      }))
    },
    [fetchReferencedValues]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchSnapshotData(snapshotUuid)
        setPartialRows(result)
      } catch (error) {
        console.error('Failed to fetch team data:', error)
        setPartialRows([])
      }
    }

    fetchData()
  }, [snapshotUuid, fetchSnapshotData])

  const rows = useMemo(
    () =>
      partialRows.map(r => {
        const selected = selectedUuids.includes(r.uuid)
        return {
          ...r,
          selected,
        } as TeamSelectRow
      }),
    [partialRows, selectedUuids]
  )
  return {
    rows,
  }
}
